
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M18.3 11.2h-.5c-1.7.3-2.8-.3-3.7-1.9-.6 1.1-2.3 1.9-3.8 1.9-.7 0-1.3-.1-1.9-.5M11.2 16.9v2.8l-5 1.8c-1.2.4-2 1.6-2 2.8v1.9h19v-1.9c0-1.3-.8-2.4-2-2.8l-5-1.8v-2.8"}}),_c('ellipse',{staticClass:"st0",attrs:{"cx":"13.7","cy":"11.8","rx":"5","ry":"6"}}),_c('path',{staticClass:"st1",attrs:{"d":"M24.7 24.4h3.1v-1.8c-.4-3.6-5.2-5.2-5.2-5.2 1.3-.5 2.4-2.1 2.4-3.8 0-2.5-1.7-4.5-3.7-4.5-.5 0-1 .1-1.4.4"}})])
          )
        }
      }
    